import { render } from "./SportsHome.vue?vue&type=template&id=29dd6807&scoped=true"
import script from "./SportsHome.vue?vue&type=script&lang=js"
export * from "./SportsHome.vue?vue&type=script&lang=js"

import "./SportsHome.vue?vue&type=style&index=0&id=29dd6807&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dd6807"]])

export default __exports__